/**
 * WISHLIST 
 * 
 * module de gestion de l'objet
 * wishlist
 */
import $ from "jquery";
import { services } from "../../../../helpers/service";
const utils = require('../utils').default;

const WL = (() => {
    const WL_DEFAULT_NAME = 'Liste de matériel';
    const WL_STORAGE_NAME = 'wishlists';

    const WL_ERROR_LOAD_PRODUCTS = 'Erreur pendant le chargement des produits.';
    const WL_ERROR_SERVICE_WISHLIST_PRO_LIST = 'Erreur du service "wishlist pro list".';
    const WL_ERROR_SAVE_WISHLIST = 'Erreur pendant l\'enregistrement de la liste de matériel.';
    const WL_ERROR_UPDATE_WISHLIST = 'Erreur pendant la mise à jour de la wishlist.';
    // instance JS représentant les WL
    let _WL = {
        id: '',
        currentWL: '',
        userLogged: false,
        lists: {
            part:{},
            pro:{},
        },
        currentWLData: [],
    };
    /**
     * ADD TO WISHLIST
     * 
     * Ajout de produit (ean) a une wishlist
     * @param {Array|Number} value tableau des ID ean à ajouter
     * @param {string} name nom de la wishlit cible
     * @param {string} context context pro|part
     * @returns 
     */
    const addToWishlist = (productsIds, listId, context , price) => {
        return new Promise ((resolve, reject) => {
            if (!isWishlistExist(defineSlug(listId), defineContext(context))) reject();
            listId = defineSlug(listId);
            context = defineContext(context);
            utils.debug('WL ADD TO WISHLIST', {productsIds, listId, context}); 
            productsIds = (typeof productsIds === 'number') ? [productsIds] : productsIds;
            productsIds.forEach((ean) => {
                ean = parseInt(ean);
                if (getWishlistList(listId, context).filter((product) => product.ean === ean).length) {
                    getWishlistList(listId, context).filter((product) => product.ean === ean)[0].quantity++;
                } else {
                    getWishlistList(listId, context).push({'ean': ean, 'quantity': 1 , 'price' : price});
                }
            });
    
            utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `product added : ${productsIds.join()}`, updateList: defineSlug(listId)});
            utils.dispatchCustomEvent('NOTIFICATION_ADD_PRODUCTS_TO_WISHLIST', {name: getWishlistName(listId, context), productsIds})
            resolve();
        });
    };
    /**
     * CREATE WISHLIST
     * 
     * Création d'un wishlist
     * @param {string} name nom de la nouvelle wishlist
     * @param {string} context context pro|part
     * @returns 
     */
    const createWishlist = (name, context) => {
        return new Promise( (resolve, reject) => {
            if (isWishlistExist(name, context)) reject();
            _WL.lists[defineContext(context)][defineSlug(name)] = {
                name,
                list: [],
                reduction: 0,
            }
            utils.debug('WL CREATE WISHLIST', {name, context}); 
            utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `wishlist created : ${name}`, updateList: defineSlug(name)});
            if (defineSlug(name) !== utils.slug(WL_DEFAULT_NAME)) {
                // si la nouvelle WL n'est pas une WL default 
                utils.dispatchCustomEvent('TRACKERS_CREATE_WISHLIST', {name});
            }
            resolve();
        });
    };
    /**
     * DELETE WISHLIST
     * @param {string} name 
     * @param {string} context 
     * @returns 
     */
    const deleteWishlist = (name, context) => {
        if (!isWishlistExist(name, context)) return;
        utils.debug('WL DELETE WISHLIST', {name, context}); 
        delete _WL.lists[defineContext(context)][defineSlug(name)];

        WL.setCurrentWishlist(WL.getDefaultListName());
    };
    /**
     * DEFINE CONTEXT
     * 
     * recupération du context en cours, si undefined on
     * se base sur le context du site
     * @param {string|undefined} context 
     * @returns {string}
     */
    const defineContext = (context) => {
        return (context !== undefined) ? context : utils.getContext();
    };
    /**
     * DEFINE SLUG
     * 
     * définition du slug actuel, si undefined on prend la 
     * wishlist par default
     * @param {string|undefined} name 
     * @returns {string}
     */
    const defineSlug = (name) => {
        if (name !== undefined) {
            return utils.slug(name);
        } else if (_WL.currentWL !== '') {
            return _WL.currentWL;
        } else {
            return utils.slug(WL_DEFAULT_NAME);
        }
    };
    /**
     * EMPTY WISHLIST
     * 
     * reset de la liste produit d'une WL
     * @param {string} name 
     * @param {string} context 
     * @returns 
     */
    const emptyWishlist = (name, context) => {
        if (!isWishlistExist(name, context)) return;
        utils.debug('WL EMPTY WISHLIST', {name, context}); 
        _WL.lists[defineContext(context)][defineSlug(name)].list = [];
    };
    /**
     * IS WISHLIST EXIST
     * 
     * test si la wishlist exist
     * @param {string} name nom de la wishlist
     * @param {string|undefined} context context part|pro ou partie du site actuelle
     * @returns {bool}
     */
    const isWishlistExist = (name, context) => {
        return getWishlist(name, context) !== undefined;
    };
    /**
     * IS WISHLISTS CONTEXT HAS PRODUCTS
     * 
     * Test si la ou les wishlist d'un context
     * contient des produits
     * @returns {bool}
     */
    const isWishlistsContextHasProducts = () => {
        const allWL = WL.getWishlistAllLists();
        let NOT_EMPTY = false;
        for (var list in allWL) { 
            if (WL.getWishlistList(list).length > 0) {
                NOT_EMPTY = true;
            }
        };
        return NOT_EMPTY;
    };
    /**
     * LOAD ALL WISHLISTS
     * 
     * chargement des wishlist
     * par defaut en localstorage si l'utilisateur 
     * n'est pas pro et pas connecté + création si pas de localstorage
     * sinon chargement WL via DB
     * @returns {Promise}
     */
    const loadAllWishlists = () => {
        return new Promise( (resolve, reject) => {
            // par default on charge le localstorage
            let wl = getStorage();
            if (null === wl) {
                // pas de localstorage = création localstorage
                createWishlist(WL_DEFAULT_NAME, 'part');
                createWishlist(WL_DEFAULT_NAME, 'pro');
            } else {
                // chargement dans l'instance _WL
                _WL.lists = JSON.parse(wl);
                utils.debug('WL  LOAD ALL WISHLISTS', _WL.lists); 
            }
            if (_WL.userLogged && utils.isProContext()){
                return loadWishlistFromDB().then((data) => {
                    wishlistObjectAssign(data);
                    utils.debug('WL  LOAD ALL WISHLISTS (pro)', _WL.lists); 
                    resolve();
                }).catch(() => {
                    reject();
                });
            }
            resolve();
        });
    };
    /**
     * LOAD PRODUCTS FROM IDS
     * 
     * appel d'un service pour avoir le details des 
     * produits d'une wishlist
     * @param {array} ids 
     * @param {string} shareWishlistId 
     * @returns {Promise}
     */
    const loadProductsFromIds = (ids, shareWishlistId) => {
        return new Promise (function(resolve, reject){
            let datas = { eans: ids, context: defineContext() };
            if (shareWishlistId !== undefined){
                datas = {wishlist : shareWishlistId};
            }
            services.use('wishlistdetail', datas, null).then(
                (data) => {
                    utils.debug('WL LOAD PRODUCTS FROM IDS', {data}); 
                    if( data.error != undefined ){
                        reject(data.error);
                    } else {
                        resolve(data);
                    }
                }).catch((error) => {
                    reject(error);
                });
        });
    };
    /**
     * LOAD WISHLIST FROM DB
     * 
     * récupération des wishlist PRO
     * @returns {Promise}
     */
    const loadWishlistFromDB = () => {
        return new Promise ((resolve, reject) => {
            services.use('wishlistproget', '', false).then((result) => {
                resolve(result)
            }).catch((error) => {
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error:WL_ERROR_SERVICE_WISHLIST_PRO_LIST});
                reject(error);
            });
        });
    };
    /**
     * REMOVE FROM WISHLIST
     * 
     * suppression d'un ou plusieurs 
     * produits d'un WL
     * @param {number|array} productsIds 
     * @param {string} listId 
     * @returns 
     */
    const removeFromWishlist = (productsIds, listId) => {
        return new Promise((resolve, reject) => {
            if (!isWishlistExist(defineSlug(listId))) reject();
            listId = defineSlug(listId);
            productsIds = (typeof productsIds === 'number') ? [productsIds] : productsIds;
            let wl = getWishlist(listId);
            // clean liste localstorage
            let listClean = [];
            wl.list.forEach(element => {
                if (productsIds.indexOf(element.ean) === -1) {
                    listClean.push(element);
                }
            });
            wl.list = listClean;
            if ( _WL.currentWLData !== undefined) {
                // clean liste data
                let currentWLDataClean = [];
                _WL.currentWLData.forEach(element => {
                    if (productsIds.indexOf(parseInt(element.ean)) === -1) {
                        currentWLDataClean.push(element);
                    }
                });
                _WL.currentWLData = currentWLDataClean;
            }
            utils.debug('WL PRODUCT DELETE', {productsIds, listId}); 
            utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `product remove : ${productsIds.join()}`, updateList: defineSlug(listId)});
            utils.dispatchCustomEvent('NOTIFICATION_REMOVE_PRODUCTS_FROM_WISHLIST', {name: wl.name, type:'success', productsIds})
            resolve();
        });
    };
    /**
     * RENAME WISHLIST
     * 
     * @param {string} oldName 
     * @param {string} newName 
     * @returns {Promise}
     */
    const renameWishlist = (oldName, newName) => {
        return new Promise ((resolve) => {
            for (const key in _WL.lists[defineContext()]) {
                if (Object.hasOwnProperty.call(_WL.lists[defineContext()], key)) {
                    if (key === oldName) {
                        const element = _WL.lists[defineContext()][key];
                        element.name = newName;
                        Object.defineProperty(_WL.lists[defineContext()], utils.slug(newName),
                            Object.getOwnPropertyDescriptor(_WL.lists[defineContext()], oldName));
                        delete _WL.lists[defineContext()][oldName];
                        utils.debug('WL RENAME WISHLIST', {oldName, newName}); 
                        utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `Liste rename : ${oldName}:${newName}`});
                        resolve();
                    }
                }
            }
        })
    };
    /**
     * SAVE CURRENT WISHLIST PRODUCT DATA
     * 
     * enregistrement de l'objet currentWLData
     * @param {object} data 
     */
    const saveCurrentWishlistProductData = (data) => {
        _WL.currentWLData.push(data);
    }
    /**
     * SAVE WISHLISTS
     * 
     * sauvegarde localstorage pour tous
     * sauvegarde en DB si PRO CONNECTED
     * @returns {Promise}
     */
    const saveWishlists = () => {
        return new Promise ((resolve, reject) => {
            utils.debug('WL SAVE WISHLISTS', _WL.lists); 
            setStorage(_WL.lists);
            if (_WL.userLogged) {
                let data = {};
                data.data = getWishlistAllLists('pro');
                services.use('wishlistprosave', data, null)
                    .then((data) => {
                        wishlistObjectAssign(data);
                        resolve();
                    }).catch((error) => {
                        reject(WL_ERROR_SAVE_WISHLIST);
                    });
            } else {
                resolve();
            }
        });
    };
    const updateWishlist = (name) => {
        return new Promise ((resolve, reject) => {
            utils.debug('WL UPDATE WISHLISTS', name); 
            if (_WL.userLogged) {
                let data = {name};
                data.data = name;
                services.use('wishlistproupdate', data, null)
                    .then((data) => {
                        resolve();
                    }).catch((error) => {
                        reject(WL_ERROR_UPDATE_WISHLIST);
                    });
            } else {
                resolve();
            }
        });
    }
    /**
     * WISHLIST OBJECT ASSIGN
     * 
     * on ré-assigne l'objet DB avec
     * l'objet local + test de l'intégrité 
     * de la présence de "list"
     * @param {object} data 
     */
    const wishlistObjectAssign = (data) => {
        Object.assign(_WL.lists.pro, data);
        for (const key in _WL.lists.pro) {
            if (_WL.lists.pro[key].list === undefined) _WL.lists.pro[key].list = [];
            if (_WL.lists.pro[key].reduction === undefined) _WL.lists.pro[key].reduction = 0;
        }
    };
    // GETTER
    /**
     * GET CURRENT WISHLIST
     * @returns {object}
     */
    const getCurrentWishlist = () => {
        return _WL.currentWL;
    };
    /**
     * GET DEFAULT LIST NAME
     * @returns {string}
     */
    const getDefaultListName = () => {
        return WL_DEFAULT_NAME;
    };
    /**
     * GET FLATTEN PRODUCTS IDS
     * @returns {array}
     */
    const getFlattenProductsIds = () => {
        let wl = getWishlistList();
        let listFlat = [];
        wl.forEach((item) => {
            listFlat.push(item.ean);
        });
        return listFlat;
    };
    /**
     * GET PRODUCT
     * @param {number} id 
     * @returns {object|undefined}
     */
    const getProduct = (id) => {
        let product = getWishlist().list.filter((product) => {
            return product.ean == id;
        });
        return (product.length === 1) ? product : undefined;
    };
    /**
     * GET PRODUCT DATA
     * @param {number} id 
     * @returns 
     */
    const getProductData = (id) => {
        return _WL.currentWLData.filter((product) => parseInt(product.ean) === parseInt(id))[0];
    };
    /**
     * GET PRODUCT COUNT
     * @returns {number}
     */
    const getProductCount = () => {
        return getWishlistList().length;
    };
    /**
     * GET PRODUCT QUANTITY
     * @param {number} id 
     * @returns {number}
     */
    const getProductQuantity = (id) => {
        return getWishlistList().filter((product) => product.ean === parseInt(id))[0].quantity;
    };
    /**
     * GET PRODUCTS QUANTITY TOTAL
     * @param {string} name 
     * @returns {number}
     */
    const getProductsQuantityTotal = (name) => {
        let total = 0; 
        getWishlistList(defineSlug(name)).forEach((product) => {
            total += product.quantity;
        });
        return total;
    };
    /**
     * GET STORAGE
     * @returns {object}
     */
    const getStorage = () => { return localStorage.getItem(WL_STORAGE_NAME); };
    /**
     * GET WISHLIST
     * @param {string} name 
     * @param {string} context 
     * @returns {object}
     */
    const getWishlist = (name, context) => {
        return _WL.lists[defineContext(context)][defineSlug(name)];
    };
    /**
     * GET WISHLIST ALL LISTS
     * @param {string} context 
     * @returns {array}
     */
    const getWishlistAllLists = (context) => {
        return _WL.lists[defineContext(context)];
    };
    /**
     * GET WISHLIST ALL LISTS COUNT
     * @param {string} context 
     * @returns {number}
     */
    const getWishlistAllListsCount = (context) => {
        return Object.keys(_WL.lists[defineContext(context)]).length;
    };
    /**
     * GET WISHLIST DETAILS PRODUCTS
     * @returns {array}
     */
    const getWishlistDetailsProducts = () => {
        return new Promise ((resolve, reject) => {
            if (!isWishlistExist()) reject();
            let productsList = getFlattenProductsIds();
            if (productsList.length === 0) {
                reject();
            } else {
                return loadProductsFromIds(productsList)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((error) => {
                        utils.dispatchCustomEvent('TEMPLATE_ERROR', {error:WL_ERROR_LOAD_PRODUCTS});
                        reject();
                    });
            }
        })
    };
    /**
     * GET WISHLIST FLATTEN PRODUCT
     * 
     * formatage JSON d'un product
     * @param {number} ean
     * @param {string} name
     * @param {string} cat
     * @param {string} price
     * @param {number} quantity
     * @returns {object}
     */
    const getWishlistFlattenProduct = function(ean, name, cat , price, quantity) {
        return {
            'name': name,
            'id': ean,
            'price': price,
            'brand': 'Legrand',
            'category': cat,
            'variant': '',
            'quantity': quantity
        }
    };

    /**
     * GET WISHLIST FLATTEN PRODUCTS
     * 
     * formatage JSON d'un product 
     * a partir d'un array de products
     * @param {array} products
     * @returns {array}
     */
    const getWishlistFlattenProducts = function(products) {
        let flattenProducts = [];
        products.forEach((product) => {
            flattenProducts.push(getWishlistFlattenProduct(
                product.ean,
                product.label,
                product.category,
                product.price,
                product.quantity))
        })
        return flattenProducts;
    };
    /**
     * GET WISHLIST FLATTEN PRODUCTS FROM LIST
     * 
     * @param {string} listName 
     * @returns {Promise}
     */
    const getWishlistFlattenProductsFromList = (listName) => {
        return new Promise ((resolve, reject) => {
            window.WL.setCurrentWishlist(listName);
            window.WL.getWishlistDetailsProducts().then((data) => {
                let products = data.datas.elements;
                products.forEach((product) => {
                    let quantity = window.WL.getProductQuantity(product.ean);
                    product.quantity = quantity;
                });
                products = window.WL.getWishlistFlattenProducts(products);
                resolve(products);
            }).catch(() => {
                resolve([]);
            });
        });
    };
    /**
     * GET WISHLIST FLATTEN PRODUCTS TRANSACTION
     * @returns {array}
     */
    const getWishlistFlattenProductsTransaction = () => {
        let flattenProductsTransaction = [];
        _WL.currentWLData.forEach((product) => {
            flattenProductsTransaction.push({
                'name': product.name,
                'id': product.ean,
                'price': product.price,
                'brand': product.brand || 'Legrand',
                'category': product.category || '',
                'variant': '',
                'quantity': product.quantity
            });
        });
        return flattenProductsTransaction;
    };
    /**
     * GET WISHLIST GRAND TOTAL
     * @returns {number}
     */
    const getWishlistGrandTotal = () => {
        let grandTotal = 0;
        _WL.currentWLData.forEach((product) => {
            grandTotal += product.price * product.quantity;
        });
        return parseFloat(grandTotal).toFixed(2);
    };
    /**
     * GET WISHLIST LIST
     * @param {string} name 
     * @param {string} context 
     * @returns {array}
     */
    const getWishlistList = (name, context) => {
        return _WL.lists[defineContext(context)][defineSlug(name)].list;
    };
    /**
     * GET WISHLIST LIST FLATTEN
     * @param {string} name 
     * @param {string} context 
     * @returns {array}
     */
    const getWishlistListFlatten = (name, context) => {
        let list = _WL.lists[defineContext(context)][defineSlug(name)].list;
        let listFlatten = [];
        list.forEach(product => {
            for (let index = 0; index < product.quantity; index++) {
                listFlatten.push(product.ean)
            }
        });
        return listFlatten;
    };
    /**
     * GET WISHLIST NAME
     * @param {string} name 
     * @param {string} context 
     * @returns {string}
     */
    const getWishlistName = (name, context) => {
        return _WL.lists[defineContext(context)][defineSlug(name)].name;
    };
    /**
     * GET WISHLIST ID
     * @param {string} name 
     * @param {string} context 
     * @returns {string}
     */
    const getWishlistId = (name, context) => {
        return utils.slug(_WL.lists[defineContext(context)][defineSlug(name)].name);
    };
    /**
     * GET WISHLIST REDUCTION
     * @param {string} name 
     * @returns {number}
     */
    const getWishlistReduction = (name) => {
        // return parseInt(getWishlist(defineSlug(name)).reduction);
        // disabled de la fonctionnalité reduction
        return 0;
    };
    /**
     * GET WISHLISTS BUT CURRENT
     * @returns {array}
     */
    const getWishListsButCurrent = () => {
        let wishlists = [];
        for (let key in _WL.lists[defineContext()]) {
            if (key !== _WL.currentWL) {
                wishlists.push({
                    slug:key, 
                    name: _WL.lists[defineContext()][key].name,
                    quantity: _WL.lists[defineContext()][key].list.length,
                });
            }
        }
        return wishlists;
    };
    /**
     * GET WISHLISTS WITH CURRENT
     * @returns {array}
     */
    const getWishListsWithCurrent = () => {
        let wishlists = [];
        for (let key in _WL.lists[defineContext()]) {
            wishlists.push({
                slug:key, 
                name: _WL.lists[defineContext()][key].name,
                quantity: _WL.lists[defineContext()][key].list.length,
            });
        }
        return wishlists;
    };
    /**
     * GET WISHLIST SERIALIZED
     * @param {string} name 
     * @param {bool} stringify 
     * @returns {string}
     */
    const getWishlistSerialized = (name, stringify) => {
        if (stringify === undefined) stringify = true;
        let serializedProducts = {};
        let wl = getWishlistList(name);
        wl.forEach((product) => {
            serializedProducts[product.ean] = product.quantity;
        });
        if (stringify) return JSON.stringify(serializedProducts);
        return serializedProducts;
    };
    // SETTER
    /**
     * SET CURRENT WISHLIST
     * @param {string} name 
     */
    const setCurrentWishlist = (name) => {
        _WL.currentWL = (name !== undefined) && isWishlistExist(name) ? 
            utils.slug(name) :
            utils.slug(WL_DEFAULT_NAME);
    };
    /**
     * SET PRODUCT DATA
     * @param {number} id 
     * @param {string} key 
     * @param {string} value 
     */
    const setProductData = (id, key, value) => {
        _WL.currentWLData.filter((product) => parseInt(product.ean) === parseInt(id))[0][key] = value;
    };
    /**
     * SET PRODUCT QUANTITY
     * @param {number} id 
     * @param {number} quantity 
     */
    const setProductQuantity = (id, quantity) => {
        getWishlistList().filter((product) => product.ean === id)[0].quantity = quantity;
        let productData = getProductData(id);
        let name = productData.name;
        let totalPrice = utils.getFormatedPrice(quantity * productData.price);
        setProductData(id, 'quantity', quantity);
        utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `product Quantity changed ean: ${id} | id: ${quantity}`, updateList: getCurrentWishlist()});
        utils.dispatchCustomEvent('WISHLIST_PRODUCT_QUANTITY_CHANGED', {id, quantity, totalPrice});
        utils.dispatchCustomEvent('TRACKERS_WISHLIST_PRODUCT_QUANTITY_CHANGE', {name, quantity, totalPrice});
    };
    /**
     * SET REDUCTION
     * @param {number} reduction 
     */
    const setReduction = (reduction) => {
        getWishlist().reduction = reduction;
        utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `Nouvelle remise: ${reduction}%`, updateList: getCurrentWishlist()});
    };
    /**
     * SET STORAGE
     * @param {object} data 
     */
    const setStorage = (data) => { localStorage.setItem(WL_STORAGE_NAME, JSON.stringify(data)); };
    /**
     * SET USER LOGGED
     * @param {bool} val 
     */
    const setUserLogged = (val) => { _WL.userLogged = typeof val === 'boolean' ? val : false;};
    return {
        _WL,
        addToWishlist,
        createWishlist,
        deleteWishlist,
        emptyWishlist,
        isWishlistExist,
        isWishlistsContextHasProducts,
        loadAllWishlists,
        loadProductsFromIds,
        removeFromWishlist,
        renameWishlist,
        saveCurrentWishlistProductData,
        saveWishlists,
        updateWishlist,
        // guetter
        getCurrentWishlist,
        getDefaultListName,
        getFlattenProductsIds,
        getProduct,
        getProductCount,
        getProductData,
        getProductQuantity,
        getProductsQuantityTotal,
        getWishlist,
        getWishlistAllLists,
        getWishlistAllListsCount,
        getWishlistDetailsProducts,
        getWishlistFlattenProduct,
        getWishlistFlattenProducts,
        getWishlistFlattenProductsFromList,
        getWishlistFlattenProductsTransaction,
        getWishlistGrandTotal,
        getWishlistList,
        getWishlistListFlatten,
        getWishlistName,
        getWishlistId,
        getWishlistReduction,
        getWishListsButCurrent,
        getWishListsWithCurrent,
        getWishlistSerialized,
        // setter
        setCurrentWishlist,
        setProductData,
        setProductQuantity,
        setReduction,
        setUserLogged,
    }
})();
export default WL;